
<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="activePage"
            :pagination="{ doubleArrows: false, align: 'center'}"
            @page-change="pageChange"
          ></CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "Village",
  data() {
    return {
      items: [],
      fields: [
        { key: "village_id", label: "ID Kelurahan" },
        { key: "sub_district_name", label: "Nama Kota" },
        { key: "village_name", label: "Nama Keluarahan" },
        { key: "status", label: "Status" }
        // { key: "district_name", label: "Nama Kota" },
        // { key: "status", label: "Status" }
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token")
    };
  },
  mounted() {
    this.authentication();
    this.getProvince();
    this.getDistrict();
    this.getSubDistrict();
    this.getVillage();
    this.$store.commit("setArrayDistrictNull");
    this.$store.commit("setArrayProvinceNull");
    this.$store.commit("setArraySubDistrictNull");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      }
    }
  },
  beforeMount() {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getProvince() {
      axios
        .get(`${this.domain}/v1/location/province/data`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json"
          }
        })
        .then(response => {
          // JSON responses are automatically parsed.
          response.data.data.forEach(Element => {
            this.$store.commit("setArrayProvince", Element);
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    getDistrict() {
      this.$store.getters.getProvince.forEach(Element => {
        axios
          .get(
            `${this.domain}/v1/location/district/data?page=1&per_page=1844674407370955161&province_id=${Element.province_id}`,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            // JSON responses are automatically parsed.
            response.data.data.forEach(Element => {
              this.$store.commit("setArrayDistrict", Element);
            });
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    getSubDistrict() {
      this.$store.getters.getDistrict.forEach(Element => {
        axios
          .get(
            `${this.domain}/v1/location/subdistrict/data?page=1&per_page=1844674407370955161&district_id=${Element.district_id}`,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            // JSON responses are automatically parsed.
            response.data.data.forEach(district => {
              this.$store.commit("setArraySubDistrict", district);
            });
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
     getVillage() {
      this.$store.getters.getSubDistrict.forEach(Element => {
        axios
          .get(
            `${this.domain}/v1/location/village/data?page=1&per_page=1844674407370955161&sub_district_id=${Element.sub_district_id}`,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json"
              }
            }
          )
          .then(response => {
            // JSON responses are automatically parsed.
            response.data.data.forEach(district => {
               this.items.push({
                village_id: district.village_id,
                sub_district_name: Element.sub_district_name,
                village_name: district.village_name,
                status: district.status
              });
            });
          })
          .catch(e => {
            console.log(e);
          });
      });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    }
  }
};
</script>
